import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  viewBox: "0 0 16 18",
  "aria-hidden": "true"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("rect", {
  x: "2.4",
  y: "8",
  width: "11.2",
  height: "8.2",
  rx: "1.4"
}, null, -1)
const _hoisted_4 = {
  key: 0,
  d: "M5 8V5.1a3 3 0 0 1 6 0V8"
}
const _hoisted_5 = {
  key: 1,
  d: "M5 8V5.2a3 3 0 0 1 5.7-1.3"
}
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "round" }
const _hoisted_8 = { class: "good-road-name" }
const _hoisted_9 = {
  key: 0,
  class: "good-road-name-text"
}
const _hoisted_10 = { class: "timer-wrap" }
const _hoisted_11 = { class: "body" }
const _hoisted_12 = { class: "bet-wrap" }
const _hoisted_13 = { class: "bet-side" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "bet-ratio" }
const _hoisted_17 = {
  key: 0,
  class: "bet-coin"
}
const _hoisted_18 = { class: "coin" }
const _hoisted_19 = { class: "label" }
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { class: "bet-ratio" }
const _hoisted_22 = {
  key: 0,
  class: "bet-coin"
}
const _hoisted_23 = { class: "coin" }
const _hoisted_24 = { class: "action-row" }
const _hoisted_25 = {
  key: 0,
  class: "btn-loading"
}
const _hoisted_26 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_road_map_view = _resolveComponent("road-map-view")
  const _component_app_svg = _resolveComponent("app-svg")
  const _component_good_road_card_result = _resolveComponent("good-road-card-result")

  return (_openBlock(), _createBlock("div", {
    class: ["m-good-road-item-root", { 'is-dragon-tiger': _ctx.isDragonTiger }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("button", {
        type: "button",
        class: ["pin-btn", { pinned: _ctx.pinned }],
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onTogglePin && _ctx.onTogglePin(...args)), ["stop"]))
      }, [
        (_openBlock(), _createBlock("svg", _hoisted_2, [
          _hoisted_3,
          (_ctx.pinned)
            ? (_openBlock(), _createBlock("path", _hoisted_4))
            : (_openBlock(), _createBlock("path", _hoisted_5))
        ]))
      ], 2),
      _createVNode("span", _hoisted_6, _toDisplayString(_ctx.title), 1),
      _createVNode("span", _hoisted_7, _toDisplayString(_ctx.roundLabel), 1),
      _createVNode("span", _hoisted_8, [
        (_ctx.goodRoadName)
          ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(_ctx.goodRoadName), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("span", {
          class: ["timer", _ctx.timerClass]
        }, _toDisplayString(_ctx.timerLabel), 3)
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", {
        class: "map-wrap",
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.enterDesk && _ctx.enterDesk(...args)), ["stop"]))
      }, [
        _createVNode(_component_road_map_view, {
          class: "map",
          display: 3,
          mapData: _ctx.deskResult
        }, null, 8, ["mapData"])
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode("div", {
            class: ["bet-btn player", {
                        active:
                            _ctx.selectedBetArea === 'player' || _ctx.blueTemp > 0,
                        blur: !_ctx.allowBet,
                        'has-unconfirm-bet': _ctx.blueTemp > 0,
                        'has-confirmed-bet':
                            _ctx.blueConfirmed > 0 && _ctx.blueTemp <= 0
                    }],
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.placeBetSide('player')))
          }, [
            _createVNode("div", _hoisted_14, [
              _createVNode("span", _hoisted_15, _toDisplayString(_ctx.playerLabel), 1),
              _createVNode("span", _hoisted_16, _toDisplayString(_ctx.playerBetRatio), 1)
            ]),
            (_ctx.showPlayerBetInfo)
              ? (_openBlock(), _createBlock("div", _hoisted_17, [
                  _createVNode(_component_app_svg, {
                    box: '0 0 67 57',
                    id: 'chip',
                    className: 'chip-svg',
                    fill: 'rgb(221, 194, 140)',
                    stroke: 'rgb(221, 194, 140)'
                  }, null, 8, ["fill", "stroke"]),
                  _createVNode("span", _hoisted_18, _toDisplayString(_ctx.playerBetAmount), 1)
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode("div", {
            class: ["bet-btn banker", {
                        active: _ctx.selectedBetArea === 'banker' || _ctx.redTemp > 0,
                        blur: !_ctx.allowBet,
                        'has-unconfirm-bet': _ctx.redTemp > 0,
                        'has-confirmed-bet':
                            _ctx.redConfirmed > 0 && _ctx.redTemp <= 0
                    }],
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.placeBetSide('banker')))
          }, [
            _createVNode("div", _hoisted_19, [
              _createVNode("span", _hoisted_20, _toDisplayString(_ctx.bankerLabel), 1),
              _createVNode("span", _hoisted_21, _toDisplayString(_ctx.bankerBetRatio), 1)
            ]),
            (_ctx.showBankerBetInfo)
              ? (_openBlock(), _createBlock("div", _hoisted_22, [
                  _createVNode(_component_app_svg, {
                    box: '0 0 67 57',
                    id: 'chip',
                    className: 'chip-svg',
                    fill: 'rgb(221, 194, 140)',
                    stroke: 'rgb(221, 194, 140)'
                  }, null, 8, ["fill", "stroke"]),
                  _createVNode("span", _hoisted_23, _toDisplayString(_ctx.bankerBetAmount), 1)
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _createVNode("div", _hoisted_24, [
          _createVNode("button", {
            class: "action-btn cancel",
            disabled: _ctx.cancelDisabled,
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelSelection && _ctx.cancelSelection(...args)))
          }, " 取消 ", 8, ["disabled"]),
          _createVNode("button", {
            class: ["action-btn confirm", { loading: _ctx.hasPendingRequest }],
            disabled: _ctx.confirmDisabled,
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.confirmSelection && _ctx.confirmSelection(...args)))
          }, [
            (_ctx.hasPendingRequest)
              ? (_openBlock(), _createBlock("span", _hoisted_25))
              : (_openBlock(), _createBlock("span", _hoisted_26, "确定"))
          ], 10, ["disabled"])
        ]),
        (_ctx.showMessage)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: ["pop-message", _ctx.messageType]
            }, [
              _createVNode("span", null, _toDisplayString(_ctx.message), 1)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showCardResult && _ctx.currentGameResult)
        ? (_openBlock(), _createBlock(_component_good_road_card_result, {
            key: 0,
            class: "card-result-row",
            gameTypeNo: _ctx.mdata.gameTypeNo,
            gameResult: _ctx.currentGameResult,
            offSound: true
          }, null, 8, ["gameTypeNo", "gameResult"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}